module.exports = __webpack_public_path__ + "media/images/lp/achievement4-sp-24b969418723b97d99c59b15a76a253e.png";